import React, { useState, useEffect, useCallback } from "react";
import UpcomingEditingBookingTable from "../UpcomingEditingComponent/UpcomingEditingBookingTable/UpcomingEditingBookingTable";
import { getEditingBookingsAPI } from "../../../utils/APIs/hourlyAndEditingBookingsApis";
import Loader from "../../../Loader/Loader";

const LIMIT = 10;

const PreviousEditingPage = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getEditingBookingsAPI(page, LIMIT, "previous");
      if (res.data && res.data.success) {
        setData(res.data.data || []);
        setTotal(res.data.meta?.total || 0);
      }
    } catch (error) {
      console.error("Error fetching previous editing bookings:", error);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const totalPages = Math.ceil(total / LIMIT);

  if (loading && data.length === 0) return <Loader />;

  return (
    <>
      <UpcomingEditingBookingTable
        data={data}
        page={page}
        limit={LIMIT}
        refetchData={fetchData}
      />

      {total > LIMIT && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="pagination-info">
            Page {page} of {totalPages}
          </span>

          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default PreviousEditingPage;
